// extracted by mini-css-extract-plugin
module.exports = {"title":"CardTitle_title__Tjmg2","applicationItem":"CardTitle_applicationItem__f0zLf","small":"CardTitle_small___ExiM"};